import styles from "../../styles/components/blogs/Pagination.module.css"

/**
 * Reusable Pagination Component
 * @param {Object} props
 * @param {number} props.currentPage - Current active page
 * @param {number} props.totalPages - Total number of pages
 * @param {function} props.onPageChange - Callback function when page changes
 * @param {Object} props.queryParams - Additional query parameters to maintain in URL
 */
export default function Pagination({ currentPage, totalPages, onPageChange, queryParams = {} }) {

  // Handle page change
  const handlePageChange = (page) => {
    onPageChange(page)
  }

  // Don't render if only one page
  if (totalPages <= 1) return null

  return (
    <div className={styles.paginationContainer}>
      <nav className={styles.pagination}>
        <button
          className={`${styles.pageBtn} ${currentPage === 1 ? styles.disabled : ""}`}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {(() => {
          const pages = []
          const maxVisiblePages = 4
          
          if (totalPages <= maxVisiblePages) {
            // Show all pages if total is small
            for (let i = 1; i <= totalPages; i++) {
              pages.push(i)
            }
          } else {
            // Smart pagination logic
            if (currentPage <= 2) {
              // Show first 4 pages
              for (let i = 1; i <= maxVisiblePages; i++) {
                pages.push(i)
              }
            } else if (currentPage >= totalPages - 1) {
              // Show last 4 pages
              for (let i = totalPages - maxVisiblePages + 1; i <= totalPages; i++) {
                pages.push(i)
              }
            } else {
              // Show current page with context
              const start = Math.max(1, currentPage - 1)
              const end = Math.min(totalPages, currentPage + 2)
              for (let i = start; i <= end; i++) {
                pages.push(i)
              }
            }
          }

          return pages.map((pageNum) => (
            <button
              key={pageNum}
              className={`${styles.pageBtn} ${currentPage === pageNum ? styles.active : ""}`}
              onClick={() => handlePageChange(pageNum)}
            >
              {pageNum}
            </button>
          ))
        })()}

        <button
          className={`${styles.pageBtn} ${currentPage === totalPages ? styles.disabled : ""}`}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </nav>
    </div>
  )
}
